import { useCallback, useContext } from 'react'

import { getTopOffers } from 'legacy/services/offers'
import { sentry } from 'legacy/utils/sentry'

import { useAnalytics } from '../../hooks/useAnalytics'
import { TopOffersContext } from './TopOffersContext'
import {
  FETCH_TOP_OFFERS,
  FETCH_TOP_OFFERS_FULFILLED,
  FETCH_TOP_OFFERS_REJECTED,
  REMOVE_TOP_OFFER,
} from './topOffersReducer'

function useTopOffers() {
  const [state, dispatch] = useContext(TopOffersContext)
  const { analytics } = useAnalytics()

  const fetchTopOffers = useCallback(() => {
    dispatch({ type: FETCH_TOP_OFFERS })
    getTopOffers()
      .then(data => {
        dispatch({ type: FETCH_TOP_OFFERS_FULFILLED, payload: data })
        analytics.track(['Top Offers', 'View'], {
          loads: data.map(offer => offer.uuid),
        })
        if (data.length) analytics.trackIntercom(['Viewed Top Offers'])
      })
      .catch(error => {
        sentry.log('[useTopOffers::fetchTopOffers] failed to fetch top offers', error)

        dispatch({
          type: FETCH_TOP_OFFERS_REJECTED,
          payload: error,
        })
      })
  }, [dispatch, analytics])

  const toggleTopOffers = useCallback(
    state => {
      analytics.track(['Top Offers', 'Toggle'], { state })
    },
    [analytics]
  )

  const removeTopOffer = useCallback(
    uuid => {
      dispatch({ type: REMOVE_TOP_OFFER, payload: uuid })
    },
    [dispatch]
  )

  return {
    ...state,
    fetchTopOffers,
    removeTopOffer,
    toggleTopOffers,
  }
}

export { useTopOffers }
